import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { MODULE } from "@/constants/testIds";

const META = {
  shop:      { eyebrow: "Commerce",        title: "Lifted Shop",            blurb: "Shopify remains source-of-truth for products, inventory, customers, orders, checkout and payments. This shell wires into the Shopify sync layer in a later phase.", roadmap: ["Shopify sync layer", "Affiliate-attributed cart", "Customer / order history", "Recommendation surfaces"] },
  training:  { eyebrow: "Lifted Academy",  title: "Training Platform",      blurb: "32+ routes, certifications, seminars, trainers, teachers and access codes — all powered by your unified Lifted identity.", roadmap: ["Course catalog & player", "Certifications & progress", "Seminar & announcement system", "Trainer / teacher consoles"] },
  affiliate: { eyebrow: "Growth",          title: "Affiliate Command",      blurb: "Track referrals, tiers, share assets and commission balances tied to one identity across Shopify orders.", roadmap: ["Referral attribution", "Tier engine", "Commission ledger", "Promotional asset library"] },
  delivery:  { eyebrow: "Operations",      title: "Delivery Operations",    blurb: "Driver onboarding, dispatch, routes, earnings and same-day delivery — shared with franchise territories.", roadmap: ["Driver onboarding flow", "Route & dispatch board", "Earnings ledger", "Live delivery tracking"] },
  partner:   { eyebrow: "Network",         title: "Partner Network",        blurb: "Partner orders & fulfillment, training and certification — all under one identity.", roadmap: ["Partner onboarding", "Order pipeline", "Fulfillment tools", "Training enforcement"] },
  franchise: { eyebrow: "Territories",     title: "Franchise Command",      blurb: "Territory ownership, driver / partner management and local reporting for franchisees.", roadmap: ["Territory map", "Driver / partner roster", "Local KPIs", "Franchisee training"] },
};

export default function ModulePlaceholder({ moduleKey, requirePermission }) {
  const meta = META[moduleKey];
  const [overview, setOverview] = useState(null);

  useEffect(() => {
    api.get(`/modules/${moduleKey}/overview`).then((r) => setOverview(r.data)).catch(() => setOverview(false));
  }, [moduleKey]);

  return (
    <div data-testid={MODULE.page(moduleKey)} className="space-y-10">
      <header className="fade-up">
        <div className="eyebrow">{meta.eyebrow}</div>
        <h1 className="headline-xl">{meta.title}</h1>
        <p className="text-lifted-dim mt-3 max-w-2xl">{meta.blurb}</p>
      </header>

      <section className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <div className="glass-panel p-6 lg:col-span-2 fade-up delay-1">
          <div className="eyebrow !text-lifted-text-dim">Module status</div>
          <div className="mt-3 flex items-center gap-3">
            <span className="chip chip--purple">Foundation ready</span>
            <span className="chip">Build in upcoming session</span>
          </div>
          <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3">
            {meta.roadmap.map((r) => (
              <div key={r} className="flex items-start gap-2 text-sm text-lifted-text">
                <span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-lifted-green" />
                {r}
              </div>
            ))}
          </div>
        </div>
        <div className="glass-panel p-6 fade-up delay-2">
          <div className="eyebrow !text-lifted-text-dim">Backend overview</div>
          <pre className="mt-3 text-[0.7rem] text-lifted-dim whitespace-pre-wrap break-all">
{overview === null ? "Loading…" : overview === false ? "Failed to load." : JSON.stringify(overview, null, 2)}
          </pre>
          <div className="eyebrow !text-lifted-text-dim mt-5">Required permission</div>
          <code className="block mt-2 text-xs text-lifted-green">{requirePermission}</code>
        </div>
      </section>
    </div>
  );
}
